import { extendTheme } from "@chakra-ui/react";

const Theme = extendTheme({
  fonts: {
    heading: `'Titillium Web', sans-serif`,
    body: `'Titillium Web', sans-serif`,
  },
});

export default Theme;
